import Units from "../../../utils/Units";
import MoistureAxes from "../axes/Moisture";
import Time from "../axes/Time";

let Moisture = {
    type: "line",
    label: "Soil Moisture (%)",
    fill: true,
    lineTension: 0,
    colorPalette: 9,
    borderWidth:2,

    pointStyle: "circle",
    pointRadius:0,
    pointHoverRadius: 2,
    pointBorderWidth:.5,
    z:50,

    tooltipLabelValueCallback: (value) => {
        return Units.rounded(value,2);
    },

    yAxis:MoistureAxes,
    xAxis:Time
};

export default Moisture;



// WEBPACK FOOTER //
// ./src/components/chart/channels/Moisture.js